import { request } from './request';

export const sharedApi = {
  getTenantProfile: () => request('/api/tenants/profile'),
  updateTenantProfile: (data) => request('/api/tenants/profile', { method: 'PUT', body: JSON.stringify(data) }),
  changeTenantPassword: (data) => request('/api/tenants/password', { method: 'PUT', body: JSON.stringify(data) }),

  getNotifications: (params, options = {}) => {
    const qs = params ? '?' + new URLSearchParams(params).toString() : '';
    return request(`/api/notifications${qs}`, options);
  },
  markNotificationRead: (id) => request(`/api/notifications/${id}/read`, { method: 'PATCH' }),
  markAllNotificationsRead: () => request('/api/notifications/read-all', { method: 'POST' }),
  getUnreadNotificationCount: (options) => request('/api/notifications/unread-count', options),

  getCountries: () => request('/api/countries'),
  getCities: (countryId) => request(`/api/countries/${countryId}/cities`),
  getCity: (cityId) => request(`/api/cities/${cityId}`),
  getRegions: (cityId) => request(`/api/cities/${cityId}/regions`),

  getCompanyBranding: () => request('/api/company/branding'),

  getCompanyBySlug: (slug) => request(`/api/companies/${encodeURIComponent(slug)}`),
  getCompaniesList: () => request('/api/companies-list'),
  submitDemoRequest: (data) => request('/api/demo-request', { method: 'POST', body: JSON.stringify(data) }),
  getHostContext: () => request('/api/host-context'),
  getFirebaseConfig: () => request('/api/push/firebase-config'),
  getPushStatus: () => request('/api/push/status'),
  registerFcm: (data) => request('/api/push/fcm/register', { method: 'POST', body: JSON.stringify(data) }),
  unregisterFcm: (data) => request('/api/push/fcm/unregister', { method: 'DELETE', body: JSON.stringify(data) }),
  trackOrder: (trackingId, companyId) => {
    const qs = companyId ? `?company_id=${encodeURIComponent(companyId)}` : '';
    return request(`/api/track/${encodeURIComponent(trackingId)}${qs}`);
  },

  /** Public currency list (no auth). */
  getPublicCurrencies: () => request('/api/currencies'),
};